module.exports = __webpack_public_path__ + "img/sv83.787f73b3.svg";